import 'bstreeview/dist/js/bstreeview.min';
import axios from 'axios';

const getAssetsTree = async () => {
  try {
    const res = await axios.get('/assets_tree');
    $('#assets-tree').bstreeview({
      data: res.data,
    });
  } catch (error) {
    console.log(error);
  }
};

document.addEventListener('turbolinks:load', () => {
  if ($('#assets-tree').length) {
    // logic to generate tree structure
    getAssetsTree();
  }
});
